var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCrowdenergy179(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.2 99.2",
    style: {
      enableBackground: "new 0 0 99.2 99.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_50"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M47.9,14.7c-19.3,0-35,15.6-35,35c0,19.3,15.6,35,35,35c19.3,0,35-15.6,35-35C82.9,30.3,67.2,14.7,47.9,14.7z  M71.2,72.9c-6,6-14.2,9.7-23.3,9.7c-9.1,0-17.3-3.7-23.3-9.7c-6-6-9.7-14.2-9.7-23.3c0-9.1,3.7-17.3,9.7-23.3 c6-6,14.2-9.7,23.3-9.7c9.1,0,17.3,3.7,23.3,9.7c6,6,9.7,14.2,9.7,23.3C80.9,58.7,77.2,66.9,71.2,72.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M50,30.2c4.2,0,8,1.3,11.2,3.6c0.5,0.3,1.1,0.2,1.4-0.2c0.3-0.5,0.2-1.1-0.2-1.4l0,0 c-3.5-2.5-7.7-3.9-12.3-3.9c-10.5,0-19.2,7.5-21,17.5h-2.5c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h2.3c-0.1,0.6-0.1,1.3-0.1,1.9 c0,0.6,0,1.3,0.1,1.9h-2.3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1H29C30.8,63.4,39.5,71,50,71c4.6,0,8.8-1.5,12.3-3.9 c0.5-0.3,0.6-0.9,0.2-1.4c-0.3-0.5-0.9-0.6-1.4-0.2C58,67.6,54.1,69,50,69c-5.4,0-10.2-2.2-13.7-5.7c-2.6-2.6-4.5-6-5.3-9.8h25.3 c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1H30.7c-0.1-0.6-0.1-1.3-0.1-1.9c0-0.6,0-1.3,0.1-1.9h25.6c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1H31 c0.8-3.8,2.7-7.2,5.3-9.8C39.8,32.4,44.6,30.2,50,30.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCrowdenergy179);
export default __webpack_public_path__ + "static/media/icons-crowdenergy-179.a0446a4214551a01791c79f7a6adc429.svg";
export { ForwardRef as ReactComponent };